import { createFileRoute, useParams } from '@tanstack/react-router';

import { EmptyState } from '@/components/ui.tsx';
import { useAuth } from '@/store/auth.ts';
import { TeacherAttemptsListView } from '@/views/quizzes/teacher-attempts-list-view.tsx';

// 仅教师的某 quiz 班级尝试列表。深链接到此的学生看到空状态
// （他们的尝试链接直接指向 /attempts/$attemptId）。
export const Route = createFileRoute('/_learner/courses_/$id/quizzes/$quizId/attempts/')({
  component: AttemptsListPage,
});

function AttemptsListPage() {
  const { id, quizId } = useParams({
    from: '/_learner/courses_/$id/quizzes/$quizId/attempts/',
  });
  const user = useAuth((s) => s.user);
  if (!user) return null;
  if (user.role !== 'TEACHER') {
    return <EmptyState>Class attempts are only available to teachers.</EmptyState>;
  }
  return <TeacherAttemptsListView courseId={id} quizId={quizId} />;
}
